import React, { useState } from 'react';
import moment from 'moment-timezone';
import DefaultDatePicker from 'components/Utils/DefaultDatePicker';
import DefaultButton from 'components/Utils/NewDefaultButton';
import PatientBadge from 'components/Patient/PatientBadge';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import ConfirmationButton from '../../Utils/NewDefaultButton/ConfirmationButton';

const MarkDeceased = ({ patient, onClose }) => {
  const [date, setDate] = useState(moment().unix());
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  async function onConfirm() {
    setLoading(true);
    const result = await dispatch(api.Patients.markDeceased({ patientId: patient.id, date }), {
      title: 'Mark Patient as Deceased',
      successText: 'Changes made successfully!',
    });
    setLoading(false);
    if (result && onClose) {
      onClose();
    }
  }

  return (
    <div className="mark-deceased">
      <div className="row">
        <PatientBadge patient={patient} goToProfile={false} />
      </div>
      <div className="row">
        <DefaultDatePicker
          label="Death date"
          name="date"
          value={date}
          onChange={(event, date) => setDate(date)}
        />
      </div>
      <br />
      <ConfirmationButton
        loading={loading}
        name="Confirm and Save"
        onClick={onConfirm}
        confirmation={{
          message:
            'This action is final and will unsubscribe the patient (if any subscription is active). Are you sure you want to proceed?',
        }}
      />
    </div>
  );
};

export default MarkDeceased;
